<template>
  <div class="April2022 text-NotoSansLight">
    <div class="wave w-full h-20 hidden md:block"></div>
    <section class="banner mb-4 bg-white">
      <div class="flex mb-6 container">
        <div><img src="~@/assets/images/202204/master.png" class="object-contain hidden md:block"></div>
        <div><img src="~@/assets/images/202204/mobile-bn.png" class="object-contain md:hidden"></div>
      </div>
    </section>
    <div class="main container px-4">
      <div class="fixed right-0 cursor-pointer openMenu" @click="isFixed= !isFixed">
        <img src="~@/assets/images/202204/menu/out.png" class="off object-contain">
      </div>
      <div class="fixed-btn fixed z-50 hidden xl:block" :class="{ 'fixed-btn-open': isFixed }">
        <a class="block px-3"><img src="~@/assets/images/202204/menu/menu_01.png" class="object-contain"></a>
        <a @click="toTop(0)" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202204/menu/menu_02.png" class="off object-contain">
          <img src="~@/assets/images/202204/menu/menu-on_02.png" class="on object-contain">
        </a>
        <a @click="toTop(1)" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202204/menu/menu_03.png" class="off object-contain">
          <img src="~@/assets/images/202204/menu/menu-on_03.png" class="on object-contain">
          </a>
        <a @click="toTop(2)" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202204/menu/menu_04.png" class="off object-contain">
          <img src="~@/assets/images/202204/menu/menu-on_04.png" class="on object-contain">
        </a>
        <a @click="toTop(3)" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202204/menu/menu_05.png" class="off object-contain">
          <img src="~@/assets/images/202204/menu/menu-on_05.png" class="on object-contain">
        </a>
        <a @click="toTop(4)" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202204/menu/menu_06.png" class="off object-contain">
          <img src="~@/assets/images/202204/menu/menu-on_06.png" class="on object-contain">
        </a>
        <a @click="toTop(5)" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202204/menu/menu_07.png" class="off object-contain">
          <img src="~@/assets/images/202204/menu/menu-on_07.png" class="on object-contain">
        </a>
        <a @click="toTop(6)" target="_blank" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202204/menu/menu_08.png" class="off object-contain">
          <img src="~@/assets/images/202204/menu/menu-on_08.png" class="on object-contain">
        </a>
        <a @click="toTopWeb()" target="_blank" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202204/menu/menu_09.png" class="object-contain">
        </a>
      </div>
      <section class="banner mb-4 ">
        <div class="mb-5">
          <img src="~@/assets/images/202204/tt-0.png" class="object-contain mx-auto">
        </div>
        <div class="flex flex-wrap">
          <div class="w-1/2 p-3" data-aos-delay="100" data-aos="flip-left" data-aos-once="true"><img src="~@/assets/images/202204/gift-1.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
          <div class="w-1/2 p-3" data-aos-delay="200" data-aos="flip-left" data-aos-once="true"><img src="~@/assets/images/202204/gift-2.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
          <!-- <div class="w-1/2 md:w-1/4 p-3" data-aos-delay="300" data-aos="flip-left" data-aos-once="true"><img src="~@/assets/images/202202/2000-box.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
          <div class="w-1/2 md:w-1/4 p-3" data-aos-delay="400" data-aos="flip-left" data-aos-once="true"><img src="~@/assets/images/202202/3000-box.png" class="object-contain h-auto w-full max-w-full mx-auto"></div> -->
        </div>
      </section>

      <section class="py-4 mb-4">
        <div class="mb-5">
          <img src="~@/assets/images/202204/tt-1.png" class="object-contain mx-auto">
        </div>
        <!-- <a class="mb-10 block" href="https://store.liveabc.com/products/recent/sale?tag=139" target="_blank">
          <img src="~@/assets/images/202202/livePEN-box.png" class="object-contain mx-auto">
        </a> -->
        <!-- <div class="mb-5">
          <img src="~@/assets/images/202202/third-title.png" class="object-contain mx-auto">
        </div> -->
        <div class="flex flex-wrap justify-center">
          <a @click="toTop(index)" class="hover-item p-2 md:p-3 cursor-pointer w-1/4" v-for="(item, index) in bookList" :key="index">
            <img :src="item.img_url" class="object-contain mx-auto off">
            <img :src="item.img_url_on" class="object-contain mx-auto on">
          </a>
        </div>
      </section>
      <section class="section py-4 mb-4" v-for="(item, index) in sectionData" :key="index" :id="'section' + index">
        <div class="flex justify-center items-center mb-8">
          <div class="px-2 md:px-4">
            <img :src="item.img_url" class="object-contain mx-auto">
          </div>
        </div>

        <div class="flex flex-wrap mb-6">
          <router-link :to="{ name: 'detail', params: { category: 'book', id: child.id } }" class="item w-1/2 md:w-1/3 lg:w-1/4 p-3 cursor-pointer" v-for="(child, idx) in item.items" :key="idx">

            <div class="item-inner bg-white rounded-3xl p-4 md:p-6 h-full flex flex-col justify-between hover:shadow-xl shadow-gray-900 border-2 border-blue" v-if="renderComponent">
              <div>
                <div class="title p-1 rounded-lg lg:rounded-full mb-3">
                  <h6 class="text-white text-center">{{ child.introduction }}</h6>
                </div>
                <div class="outer mb-2">
                  <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 absolute w-full h-full">
                    <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!child.cover">
                    <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                  </div>
                </div>
                <div>
                  <div>
                    <dealBookName :nameVal="child.name" v-if="child.name" class="text-center whitespace-pre-wrap" />
                  </div>
                </div>
              </div>

              <div class="flex flex-col md:flex-row md:justify-center md:items-end mt-3 flex-wrap" v-if="child.name">
                <p v-if="child.type === 'PACKAGE'" class="fixed_price line-through">原價:{{ child.fixed_price }}</p>
                <p v-if="child.type === 'BOOK'"><span class="pricing">{{ child.display_discount }}</span>折</p>
                <p>特價:<span class="pricing">{{ child.pricing }}</span></p>
              </div>
            </div>
          </router-link>
        </div>
        <div class="flex items-center">
          <div class="hidden md:block md:flex-1 border-t-2 h-0 border-dotted dotted relative"></div>
          <a :href="item.link" class="px-6 more" target="_blank">
            <img src="~@/assets/images/202204/more-bottom.png" class="object-contain mx-auto">
          </a>
          <div class="hidden md:block md:flex-1 border-t-2 h-0 border-dotted dotted relative"></div>
        </div>
      </section>
      <section class="section py-4 mb-4" id="section6">
        <div class="flex justify-center items-center mb-8">
          <div class="px-2 md:px-4">
            <img src="@/assets/images/202204/tt-8.png" class="object-contain mx-auto">
          </div>
        </div>

        <div class="bg-white pt-2 px-4 md:px-12 border-2 border-blue rounded-3xl">
          <div class="">
            <img src="@/assets/images/202204/mg-1.png" class="object-contain mx-auto">
          </div>
          <div class="flex flex-wrap">
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="item w-1/2 lg:w-1/5 p-3 cursor-pointer" v-for="(item, idx) in planData" :key="idx">

              <div class="item-inner bg-white rounded-3xl p-2 h-full flex flex-col justify-between" v-if="renderComponent">
                <div>
                  <div class="title p-1 rounded-lg lg:rounded-full mb-3">
                    <h6 class="text-white text-center">{{ item.introduction }}</h6>
                  </div>
                  <div class="outer mb-2">
                    <div class="inner mx-auto border-0 absolute w-full h-full">
                      <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block"  v-if="!item.cover">
                      <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                    </div>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row md:justify-center md:items-end mt-3 flex-wrap">
                    <p v-if="item.text"><span class="pricing">6</span>期特價<span class="pricing">990</span></p>
                    <div class="p-1 mb-3">
                      <img src="@/assets/images/202204/order-bt.png" class="w-full h-full object-contain block">
                    </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="flex justify-end">
            <div class="w-3/4 h-o border-b border-gray-800 border-dotted pt-6 mb-6"></div>
          </div>
          <div class="flex flex-wrap">
            <div class="w-1/2 lg:w-1/5">
              <img src="@/assets/images/202204/mg-pic-1.png" class="object-contain mx-auto">
            </div>
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="item w-1/2 lg:w-1/5 p-3 cursor-pointer" v-for="(item, idx) in presentsData" :key="idx">

              <div class="item-inner bg-white rounded-3xl flex flex-col" v-if="renderComponent">
                <div>
                  <!-- <div class="title p-1 rounded-lg lg:rounded-full mb-3">
                    <h6 class="text-white text-center">{{ item.introduction }}</h6>
                  </div> -->
                  <div class="outer mb-6">
                    <div class="inner mx-auto border-0 absolute w-full h-full">
                      <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!item.cover">
                      <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                    </div>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row md:justify-center md:items-end mt-3 flex-wrap items-center text-center">
                  <p class="mb-2 text-base">{{ item.name }}</p>
                  <p>價值:<span class="pricing">{{ item.pricing }}</span>元</p>
                </div>
              </div>
            </router-link>
          </div>
          <div class="flex justify-end">
            <div class="w-full h-o border-b border-gray-800 border-dotted pt-6 mb-6"></div>
          </div>
          <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 7724 } }" >
            <img src="@/assets/images/202204/hw.png" class="object-contain mx-auto">
          </router-link>
          <div class="flex justify-end">
            <div class="w-3/4 h-o border-b border-gray-800 border-dotted pt-6 mb-6"></div>
          </div>
          <div class="flex flex-wrap">
            <div class="w-1/2 lg:w-1/5">
              <img src="@/assets/images/202204/mg-pic-2.png" class="object-contain mx-auto">
            </div>
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="item w-1/2 lg:w-1/5 p-3 cursor-pointer" v-for="(item, idx) in presentsData2" :key="idx">

              <div class="item-inner bg-white rounded-3xl flex flex-col" v-if="renderComponent">
                <div>
                  <!-- <div class="title p-1 rounded-lg lg:rounded-full mb-3">
                    <h6 class="text-white text-center">{{ item.introduction }}</h6>
                  </div> -->
                  <div class="outer mb-6">
                    <div class="inner mx-auto border-0 absolute w-full h-full">
                      <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!item.cover">
                      <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                    </div>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row md:justify-center md:items-end mt-3 flex-wrap items-center text-center">
                  <p class="mb-2 text-base">{{ item.name }}</p>
                  <p>價值:<span class="pricing">{{ item.pricing }}</span>元</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>

      </section>

      <!-- 注意事項 -->
      <section class="section6 py-3 pl-6 px-2 leading-loose text-base lg:text-lg font-bold tracking-wider">
        <p>注意事項</p>
        <ul class="list-decimal list-outside">
          <li>贈書數量有限，送完為止。</li>
          <li>本公司保留替換其他等值獎項及變更、修改本活動之權利。</li>
          <li>活動已官網公告為主，凡有變更則不另加通知。</li>
          <li>單筆訂單消費金額不包含運費或掛號費。</li>
        </ul>
      </section>

      <footer class="section6 pt-6 pb-10 flex justify-center">
        <router-link :to="{ name: 'index' }" class="block mx-auto">
          <img class="object-contain" src="~@/assets/images/202204/liveabc-logo.png" alt="livaABC">
        </router-link>
      </footer>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import jump from 'jump.js'
import dealBookName from '@/components/modules/dealBookName'
export default {
  name: 'April2022',
  metaInfo () {
    return {
      title: 'LiveABC開學書展_打造英語學爸霸',
      titleTemplate: null
    }
  },
  components: {
    dealBookName
  },
  data () {
    return {
      linksOfftop: 0,
      isFixed: false,
      renderComponent: true,

      bookList: [
        { img_url: require('@/assets/images/202204/bt-1-off.png'), img_url_on: require('@/assets/images/202204/bt-1-on.png'), link: 'https://store.liveabc.com/products/book?type=BOOK&category=102' },
        { img_url: require('@/assets/images/202204/bt-2-off.png'), img_url_on: require('@/assets/images/202204/bt-2-on.png'), link: 'https://store.liveabc.com/products/book?type=BOOK&category=113' },
        { img_url: require('@/assets/images/202204/bt-3-off.png'), img_url_on: require('@/assets/images/202204/bt-3-on.png'), link: 'https://store.liveabc.com/products/book?type=BOOK&category=101' },
        { img_url: require('@/assets/images/202204/bt-4-off.png'), img_url_on: require('@/assets/images/202204/bt-4-on.png'), link: 'https://store.liveabc.com/products/book?type=BOOK&category=103' },
        { img_url: require('@/assets/images/202204/bt-5-off.png'), img_url_on: require('@/assets/images/202204/bt-5-on.png'), link: 'https://store.liveabc.com/products/book?type=BOOK&category=110' },
        { img_url: require('@/assets/images/202204/bt-6-off.png'), img_url_on: require('@/assets/images/202204/bt-6-on.png'), link: 'https://store.liveabc.com/products/book?type=BOOK&category=111' },
        { img_url: require('@/assets/images/202204/bt-7-off.png'), img_url_on: require('@/assets/images/202204/bt-7-on.png'), link: 'https://store.liveabc.com/products/book?type=BOOK&category=111' }
      ],

      sectionData: [
        {
          img_url: require('@/assets/images/202204/tt-2.png'),
          // item_img_url: require('@/assets/images/202202/01-pic.png'),
          item_bg: '#D7F01B',
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=110',
          items: [
            { id: 7548, introduction: '學英語也能輕鬆又有趣' },
            { id: 7494, introduction: '學英語也能輕鬆又有趣' },
            { id: 7181, introduction: '學英語也能輕鬆又有趣' },
            { id: 7182, introduction: '學英語也能輕鬆又有趣' },
            { id: 6225, introduction: '學英語也能輕鬆又有趣' },
            { id: 7694, introduction: '認識26個字母大小寫' },
            { id: 7549, introduction: '教你看圖就能學好單字' },
            { id: 6935, introduction: '教你看圖就能學好單字' }
          ]
        },
        {
          img_url: require('@/assets/images/202204/tt-3.png'),
          // item_img_url: require('@/assets/images/202202/02-pic.png'),
          item_bg: '#f0b4d5',
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=110',
          items: [
            { id: 4660, introduction: '從小故事中愛上英語' },
            { id: 7268, introduction: '從小故事中愛上英語' },
            { id: 4578, introduction: '看圖記單字輕鬆學英語' },
            { id: 7445, introduction: '用英語正確表達' },
            { id: 5179, introduction: '英語檢定最佳輔助教材' },
            { id: 5476, introduction: '英語檢定最佳輔助教材' },
            { id: 5478, introduction: '奠定孩子良善的品格' },
            { id: 5563, introduction: '奠定孩子良善的品格' }
          ]
        },
        {
          img_url: require('@/assets/images/202204/tt-4.png'),
          // item_img_url: require('@/assets/images/202202/04-pic.png'),
          item_bg: '#96f288',
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=113',
          items: [
            { id: 7686, introduction: '英聽測驗必備工具書' },
            { id: 7432, introduction: '提升英文寫作素養實力' },
            { id: 7323, introduction: '嚴選高頻率必備字彙' },
            { id: 7218, introduction: '英文五大題型完整搜' },
            { id: 6610, introduction: '學習重點幫你整理好' },
            { id: 7167, introduction: '建立英語素養解題能力' },
            { id: 6757, introduction: '一本搞定必考五大題型' },
            { id: 6393, introduction: '最有效率的學習計畫' }
          ]
        },
        {
          img_url: require('@/assets/images/202204/tt-5.png'),
          // item_img_url: require('@/assets/images/202202/05-pic.png'),
          item_bg: '#c2d2f2',
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=117',
          items: [
            { id: 7496, introduction: '學會美食英語超有感' },
            { id: 7445, introduction: '掌握最道地的英語用法' },
            { id: 7405, introduction: '最實用的字彙小百科' },
            { id: 6373, introduction: '一步步搞定英語發音' },
            { id: 5026, introduction: '走入生活場景活用英語' },
            { id: 5169, introduction: '想到就說英語學易通' },
            { id: 4586, introduction: '實景圖解學習超Easy' },
            { id: 4578, introduction: '整個城市都是英語教室' }
          ]
        },
        {
          img_url: require('@/assets/images/202204/tt-6.png'),
          // item_img_url: require('@/assets/images/202202/06-pic.png'),
          item_bg: '#575ff2',
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=111',
          items: [
            { id: 7582, introduction: '全彩圖解科學秒懂好讀' },
            { id: 7355, introduction: '細究影響人類歷史里程碑' },
            { id: 7134, introduction: '見識新奇有趣的代步工具' },
            { id: 5967, introduction: '幫你一次掌握最新' },
            { id: 6615, introduction: '集結海陸空軍事特輯' },
            { id: 6189, introduction: '探索奇異美景和生物百態' },
            { id: 6007, introduction: '用科學解釋你我生活日常' },
            { id: 5977, introduction: '太陽系誕生星際太空之旅' }
          ]
        },
        {
          img_url: require('@/assets/images/202204/tt-7.png'),
          // item_img_url: require('@/assets/images/202202/06-pic.png'),
          item_bg: '#575ff2',
          link: 'https://store.liveabc.com/products/livepen?scope=livepen',
          items: [
            { id: 7235, introduction: '跟著粉紅豬小妹學英語' },
            { id: 7068, introduction: '跟著粉紅豬小妹學英語' },
            { id: 7485, introduction: '兒童英語檢定輔助教材' },
            { id: 7486, introduction: '126篇中/英對照小故事' },
            { id: 6601, introduction: '透過閱讀培養正確價值觀' },
            { id: 6569, introduction: '5大生活場景學英語會話' },
            { id: 6772, introduction: '打好英語基礎沒問題' },
            { id: 6606, introduction: '圖像記憶法學習超有感' }
          ]
        }
      ],

      planData: [
        { id: 7725, introduction: '初級/基礎/活用', text: '6期特價990' },
        { id: 7726, introduction: '中級/生活/活用', text: '6期特價990' },
        { id: 7727, introduction: '中高級/進階/活用', text: '6期特價990' },
        { id: 7728, introduction: '新聞/時事/活用', text: '6期特價990' },
        { id: 7729, introduction: '初級/生活/活用', text: '6期特價990' }
      ],
      presentsData: [
        { id: 7496 },
        { id: 7003 },
        { id: 7138 },
        { id: 6572 }
      ],
      presentsData2: [
        { id: 7355 },
        { id: 7134 },
        { id: 6615 },
        { id: 6007 }
      ]
    }
  },
  async mounted () {
    await this.getEvent()
  },
  destroyed () {
  },
  methods: {
    async getEvent () {
      let self = this
      for (let i = 0; i < self.sectionData.length; i++) {
        await self.getData(i, self.sectionData[i].items)
      }
      self.getData2(self.planData)
      self.getData2(self.presentsData)
      self.getData2(self.presentsData2)
    },
    getData (idx, itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }

      axios.get(`/products?list=${pathArr.toString()}`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },
    getData2 (itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },

    forceRerender () {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    },
    toTop (n) {
      jump(`#section${n}`, {
        duration: 500,
        offset: 0
      })
    },
    toTopWeb () {
      jump(`.April2022`, {
        duration: 600,
        offset: 0
      })
    },
    replace (name) {
      return name.replace(' ', '<br/>')
    }
  }
}
</script>
<style lang="scss" scoped>

.rounded-3xl {
  border-radius: 1.5rem;
}
.pricing {
  color: #ff0000;
}
.border-blue {
  border-color: #26456A;
}
.dotted {
  border-color: #26456A;
  &:before {
    content: "";
    position: absolute;
    width: 8px;
    height: 8px;
    background: #26456A;
    border-radius: 50%;
    top: -5px;
    left: 0;
  }
  &:after {
    content: "";
    position: absolute;
    width: 8px;
    height: 8px;
    background: #26456A;
    border-radius: 50%;
    top: -5px;
    right: 0;
  }
}
.outer {
  position: relative;
  width: 100%;
  background:white;
  display: block;
  &:after {
    content: "";
    display: block;
    padding-Bottom: 100%;
  }
  .inner {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.title {
  background-color: #3AA0B9;
}
.fixed_price {
  text-decoration-color: red;
}
.April2022 {
  .wave {
    background-color: #ffffff;
    background-image: url('~@/assets/images/202204/background.png');
  // background-size: contain;
  // background-attachment: fixed;
  }
  background-color: #F3BBAB;
  // background-image: url('~@/assets/images/202202/pattern.png');
  // background-size: contain;
  // background-attachment: fixed;

  .main {
    .openMenu {
      top: 25%;
    }
    .fixed-btn {
      top: 50%;
      transform: translateY(-50%);
      right: -100%;
      transition: 0.3s;
    }
    .fixed-btn-open {
      right: 5%;
    }
    .bg-yellow {
      background-color: #D7F01B;
    }
    .more {
      .on {
        display: none;
      }
      &:hover {
        .off {
          display: none;
        }
        .on {
          display: block;
        }
      }
    }
    .item-card {
      min-height: 360px;
    }
    .item {
      .item-inner {
        min-height: 360px;
        transition: .3s;
        &:hover {
          transform: translateY(-15px);
        }
      }
    }
    .hover-item {
      .on {
        display: none;
      }
      &:hover {
        .off {
          display: none;
        }
        .on {
          display: block;
        }
      }
    }
    .section6 {
      color: #26456A;
    }
  }
}
</style>
